/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createWorkPackageStatus } from '../fn/work-package-statuses/create-work-package-status';
import { CreateWorkPackageStatus$Params } from '../fn/work-package-statuses/create-work-package-status';
import { deleteWorkPackageStatus } from '../fn/work-package-statuses/delete-work-package-status';
import { DeleteWorkPackageStatus$Params } from '../fn/work-package-statuses/delete-work-package-status';
import { getWorkPackageStatus } from '../fn/work-package-statuses/get-work-package-status';
import { GetWorkPackageStatus$Params } from '../fn/work-package-statuses/get-work-package-status';
import { listWorkPackageStatuses } from '../fn/work-package-statuses/list-work-package-statuses';
import { ListWorkPackageStatuses$Params } from '../fn/work-package-statuses/list-work-package-statuses';
import { updateWorkPackageStatus } from '../fn/work-package-statuses/update-work-package-status';
import { UpdateWorkPackageStatus$Params } from '../fn/work-package-statuses/update-work-package-status';
import { WorkPackageStatusDto } from '../models/work-package-status-dto';
import { WorkPackageStatusDtoPage } from '../models/work-package-status-dto-page';

@Injectable({ providedIn: 'root' })
export class WorkPackageStatusesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listWorkPackageStatuses()` */
  static readonly ListWorkPackageStatusesPath = '/v0/workPackageStatuses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkPackageStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageStatuses$Response(params?: ListWorkPackageStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageStatusDtoPage>> {
    return listWorkPackageStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkPackageStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageStatuses(params?: ListWorkPackageStatuses$Params, context?: HttpContext): Observable<WorkPackageStatusDtoPage> {
    return this.listWorkPackageStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageStatusDtoPage>): WorkPackageStatusDtoPage => r.body)
    );
  }

  /** Path part for operation `getWorkPackageStatus()` */
  static readonly GetWorkPackageStatusPath = '/v0/workPackageStatuses/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkPackageStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageStatus$Response(params: GetWorkPackageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageStatusDto>> {
    return getWorkPackageStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkPackageStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkPackageStatus(params: GetWorkPackageStatus$Params, context?: HttpContext): Observable<WorkPackageStatusDto> {
    return this.getWorkPackageStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageStatusDto>): WorkPackageStatusDto => r.body)
    );
  }

  /** Path part for operation `updateWorkPackageStatus()` */
  static readonly UpdateWorkPackageStatusPath = '/v0/workPackageStatuses/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWorkPackageStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageStatus$Response(params: UpdateWorkPackageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateWorkPackageStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWorkPackageStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWorkPackageStatus(params: UpdateWorkPackageStatus$Params, context?: HttpContext): Observable<void> {
    return this.updateWorkPackageStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createWorkPackageStatus()` */
  static readonly CreateWorkPackageStatusPath = '/v0/workPackageStatuses/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkPackageStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageStatus$Response(params: CreateWorkPackageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageStatusDto>> {
    return createWorkPackageStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkPackageStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageStatus(params: CreateWorkPackageStatus$Params, context?: HttpContext): Observable<WorkPackageStatusDto> {
    return this.createWorkPackageStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageStatusDto>): WorkPackageStatusDto => r.body)
    );
  }

  /** Path part for operation `deleteWorkPackageStatus()` */
  static readonly DeleteWorkPackageStatusPath = '/v0/workPackageStatuses/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkPackageStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackageStatus$Response(params: DeleteWorkPackageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteWorkPackageStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWorkPackageStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackageStatus(params: DeleteWorkPackageStatus$Params, context?: HttpContext): Observable<void> {
    return this.deleteWorkPackageStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
